import axios from "axios";
//import {history} from '../utils/history';

import { memorizedRefreshToken } from "./refreshToken";

axios.defaults.baseURL = process.env.REACT_APP_API_URL;

axios.interceptors.request.use(
    async (config) => {
        const session = JSON.parse(localStorage.getItem("token"));
        if (session?.access) {
            config.headers = {
                ...config.headers,
                Authorization: `Bearer ${session.access}`,

            };
        }
        return config;
    },
    (error) => Promise.reject(error)
);

axios.interceptors.response.use(
    (response) => response,
    async (error) => {
        const config = error?.config;

        /* if (error?.response?.status === 401) {
            localStorage.removeItem("token");
            
                history.navigate('/logout');
            
        } */

        if (error?.response?.status === 401 && !config?.sent) {
            config.sent = true;

            const result = await memorizedRefreshToken();
            if (result?.access) {
                config.headers = {
                    ...config.headers,
                    Authorization: `Bearer ${result.access}`,
                };
            }
            return axios(config);
        }
        return Promise.reject(error);
    }
);

export const axiosPrivate = axios;